import { render, staticRenderFns } from "./SaleDetailsView.vue?vue&type=template&id=3ec1d196&scoped=true"
import script from "./SaleDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleDetailsView.vue?vue&type=script&lang=js"
import style0 from "./SaleDetailsView.vue?vue&type=style&index=0&id=3ec1d196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec1d196",
  null
  
)

export default component.exports